<app-downtime-active-message></app-downtime-active-message>
<div
    id="newRequestComponent"
    class="mat-elevation-z8"
    [ngClass]="{ 'detailColumn invoiceColumn position-relative mx-0': isEninvoice && isCustomNewRequest }"
    *transloco="let translate">
    <div class="newRequestComponentHeader">
        <div class="flex items-center justify-between">
            <span
                class="createNewProcessSpan"
                [textContent]="
                    isEninvoice && isCustomNewRequest ? translate('Create New Transaction') : translate('Create New Process')
                "></span>
            <div *ngIf="isEninvoice && isCustomNewRequest">
                <!-- Custom new request content can be added here -->
                <div>
                    <material-button
                        class="addDataBtnCls"
                        [classList]="['!w-auto', 'mx-2']"
                        [text]="translate('Manual')"
                        [color]="selectedIndex === 0 ? 'primary' : 'default'"
                        (buttonClicked)="tabClick(0)"></material-button>
                    <material-button
                        class="addDataBtnCls"
                        [classList]="['!w-auto', 'mx-2']"
                        [text]="translate('File Upload')"
                        [color]="selectedIndex === 1 ? 'primary' : 'default'"
                        (buttonClicked)="tabClick(1)"></material-button>
                    <material-button
                        class="addDataBtnCls"
                        [classList]="['!w-auto', 'mx-2']"
                        [text]="translate('Pull From App')"
                        [color]="selectedIndex === 2 ? 'primary' : 'default'"
                        (buttonClicked)="tabClick(2)"></material-button>
                </div>
            </div>
        </div>
    </div>

    <perfect-scrollbar class="newRequestComponentBody h-[calc(100vh-110px)]">
        <div *ngIf="isEninvoice && isCustomNewRequest">
            <ng-container *ngIf="filingAttributeFields?.length > 0">
                <div class="py-[30px] px-[20px] pb-[15px]">
                    <div class="flex items-center justify-between mb-[20px]">
                        <span [textContent]="translate('Define Pre-Capture Attributes')"></span>
                    </div>
                    <div class="preCaptureAttributeFieldsContainer row">
                        <ng-container *ngFor="let field of filingAttributeFields">
                            <div class="col-3" *ngIf="!field.autoCalculate && field.show && currentApp?.assetMetaUId">
                                <filingattribute-field
                                    [field]="field"
                                    [record]="filingAttributeFields"
                                    [service]="currentApp"
                                    [type]="'filingDate'"
                                    [bridge]="currentBridge"
                                    [metaData]="assetMetaData"
                                    [fieldsMap]="fieldsMap"
                                    [masterEntityFieldValueMap]="masterEntityFieldValueMap"
                                    (modelChange)="getBusinessKeyFieldValues()"></filingattribute-field>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="selectedIndex === 0">
                <ng-container *ngTemplateOutlet="manualTemplate"></ng-container>
            </div>
            <div *ngIf="selectedIndex === 1">
                <ng-container *ngTemplateOutlet="fileUpload"></ng-container>
            </div>
            <div *ngIf="selectedIndex === 2">
                <ng-container *ngTemplateOutlet="pullFromApp"></ng-container>
            </div>
            <div class="filingAttributeSubmitButn">
                <material-button
                    [classList]="['!w-auto', 'mx-2']"
                    [text]="translate('Cancel')"
                    [color]="'default'"
                    (buttonClicked)="cancelEntity(false)"></material-button>
                <material-button
                    class="addDataBtnCls"
                    [classList]="['!w-auto', 'mx-2']"
                    [text]="translate('initiate transaction')"
                    *ngIf="selectedIndex === 0"
                    [color]="'primary'"
                    (buttonClicked)="initiateNewProcess()"></material-button>
                <material-button
                    class="addDataBtnCls"
                    [classList]="['!w-auto', 'mx-2']"
                    [text]="translate('initiate transaction')"
                    *ngIf="selectedIndex === 1"
                    [color]="'primary'"
                    (buttonClicked)="initiateNewProcess()"></material-button>
                <material-button
                    class="addDataBtnCls"
                    [classList]="['!w-auto', 'mx-2']"
                    [text]="translate('initiate transaction')"
                    *ngIf="selectedIndex === 2"
                    [color]="'primary'"
                    (buttonClicked)="initiateNewProcess()"></material-button>
            </div>
        </div>
        <div class="materialStepperDiv" *ngIf="!isEninvoice || !isCustomNewRequest">
            <mat-horizontal-stepper labelPosition="bottom" #stepper [linear]="false" [class]="'currentIndex-' + stepper.selectedIndex">
                <ng-template matStepperIcon="edit" let-index="index">
                    <span [textContent]="index + 1"></span>
                </ng-template>
                <mat-step>
                    <ng-container *transloco="let translate">
                        <ng-template matStepLabel><span [textContent]="translate('Define Pre-Capture Attributes')"></span></ng-template>
                        <div class="preCaptureAttributesContainer">
                            <ng-container *ngIf="filingAttributeFields?.length > 0; else noFilingAtributes">
                                <div class="preCaptureAttributeFieldsContainer row">
                                    <ng-container *ngFor="let field of filingAttributeFields">
                                        <div class="col-3" *ngIf="!field.autoCalculate && field.show && currentApp?.assetMetaUId">
                                            <filingattribute-field
                                                [field]="field"
                                                [record]="filingAttributeFields"
                                                [service]="currentApp"
                                                [type]="'filingDate'"
                                                [bridge]="currentBridge"
                                                [metaData]="assetMetaData"
                                                [fieldsMap]="fieldsMap"
                                                [masterEntityFieldValueMap]="masterEntityFieldValueMap"
                                                (modelChange)="getBusinessKeyFieldValues()"></filingattribute-field>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                        <div class="filingAttributeSubmitButn">
                            <material-button
                                [classList]="['!w-auto', '!mx-2']"
                                [text]="translate('Cancel')"
                                [color]="'default'"
                                (buttonClicked)="cancelEntity(false)"></material-button>
                            <material-button
                                class="initiateBtnCls"
                                [text]="translate('Initiate Process')"
                                [classList]="['!w-auto', '!mx-2']"
                                [color]="'primary'"
                                *ngIf="
                                    (!transformations || (transformations && transformations.length === 0)) &&
                                    (!assetToAssetTransformations ||
                                        (assetToAssetTransformations && assetToAssetTransformations.length === 0)) &&
                                    (!businessKeysRecord || (businessKeysRecord && businessKeysRecord.fields.length === 0))
                                "
                                (buttonClicked)="submitAttributeFields()"></material-button>
                            <material-button
                                class="nextBtnCls"
                                [classList]="['!w-auto', '!mx-2']"
                                [color]="'primary'"
                                [text]="translate('Next: Add Data')"
                                *ngIf="filingAttributeFields && filingAttributeFields.length > 0"
                                (buttonClicked)="validateFilingAttributeFields()"></material-button>
                            <material-button
                                class="nextBtnCls"
                                [classList]="['!w-auto', '!mx-2']"
                                [color]="'primary'"
                                [text]="translate('Next: Add Data')"
                                *ngIf="!filingAttributeFields || filingAttributeFields.length === 0"
                                (buttonClicked)="goToNextPage()"></material-button>
                        </div>
                    </ng-container>
                </mat-step>
                <mat-step>
                    <ng-container *transloco="let translate">
                        <ng-template matStepLabel><span [textContent]="translate('Add Data')"></span></ng-template>
                        <div class="addDataHeader" *transloco="let translate">
                            <span [textContent]="translate('To initiate new process please use any one of the below options.')"></span>
                        </div>
                        <mat-tab-group #inputTypeGroup [(selectedIndex)]="selectedIndex">
                            <mat-tab [label]="translate('Electronic Form')" [ngClass]="{ 'active-tab': selectedIndex === 0 }">
                                <ng-container *ngTemplateOutlet="manualTemplate"></ng-container>
                            </mat-tab>
                            <mat-tab [label]="translate('File Upload')" [ngClass]="{ 'active-tab': selectedIndex === 1 }">
                                <ng-container *ngTemplateOutlet="fileUpload"></ng-container>
                            </mat-tab>
                            <mat-tab [label]="translate('Pull from App')" [ngClass]="{ 'active-tab': selectedIndex === 2 }">
                                <ng-container *ngTemplateOutlet="pullFromApp"></ng-container>
                            </mat-tab>
                        </mat-tab-group>
                        <div class="filingAttributeSubmitButn" id="addDataBtnDiv">
                            <material-button
                                class="pull-left"
                                [text]="translate('Back')"
                                [color]="'default'"
                                (buttonClicked)="goToBackPage()"></material-button>
                            <material-button
                                [classList]="['!w-auto', 'mx-2']"
                                [text]="translate('Cancel')"
                                [color]="'default'"
                                (buttonClicked)="cancelEntity(false)"></material-button>
                            <material-button
                                class="addDataBtnCls"
                                [classList]="['!w-auto', 'mx-2']"
                                [text]="translate('Initiate Process')"
                                *ngIf="selectedIndex === 0"
                                [color]="'primary'"
                                (buttonClicked)="initiateNewProcess()"></material-button>
                            <material-button
                                class="addDataBtnCls"
                                [classList]="['!w-auto', 'mx-2']"
                                [text]="translate('Initiate Process')"
                                *ngIf="selectedIndex === 1"
                                [color]="'primary'"
                                (buttonClicked)="initiateNewProcess()"></material-button>
                            <material-button
                                class="addDataBtnCls"
                                [classList]="['!w-auto', 'mx-2']"
                                [text]="translate('Initiate Process')"
                                *ngIf="selectedIndex === 2"
                                [color]="'primary'"
                                (buttonClicked)="initiateNewProcess()"></material-button>
                            <material-button
                                [classList]="['!w-auto', 'mx-2']"
                                [color]="'primary'"
                                [text]="translate('Next: Review')"
                                #nextBtn
                                (buttonClicked)="goToReview()"></material-button>
                        </div>
                    </ng-container>
                </mat-step>
                <mat-step>
                    <ng-container *transloco="let translate">
                        <ng-template matStepLabel><span [textContent]="translate('Review')"></span></ng-template>
                        <div class="reviewMainContainer" *transloco="let translate">
                            <div class="reviewPreCaptureAttrContainer">
                                <div class="reviewPreCaptureHeader">
                                    <span [textContent]="translate('Pre-Capture Attributes') + ':'"></span>
                                </div>
                                <div *ngIf="filingAttributeFields && filingAttributeFields.length > 0; else noFilingAtributes">
                                    <div class="requestReviewPreCaptureContainer row">
                                        <ng-container *ngFor="let field of filingAttributeFields">
                                            <div class="requestReviewFieldContainer col-3 wordBreak" *ngIf="field.show">
                                                <span
                                                    class="requestReviewFieldLabel"
                                                    [textContent]="(field?.displayName || field?.name) + ' :'"></span>
                                                <span
                                                    class="requestReviewFieldValue"
                                                    *ngIf="!(field?.values?.length > 0)"
                                                    [textContent]="field?.value"></span>
                                                <span
                                                    class="requestReviewFieldValue"
                                                    *ngIf="field?.values?.length > 0"
                                                    [textContent]="field.values"></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <ng-container [ngSwitch]="selectedIndex">
                                <ng-container *ngSwitchCase="0">
                                    <div class="requestReviewDataContainer">
                                        <div class="reviewPreCaptureHeader">
                                            <span [textContent]="translate('Business Keys') + ':'"></span>
                                        </div>
                                        <ng-container
                                            *ngIf="
                                                businessKeysRecord && businessKeysRecord.fields && businessKeysRecord.fields.length > 0;
                                                else noBusinessKeys
                                            ">
                                            <div class="row">
                                                <ng-container *ngFor="let field of businessKeysRecord.fields">
                                                    <div
                                                        class="requestReviewFieldContainer col-3 wordBreak"
                                                        *ngIf="field.isBusinessKey && field.show">
                                                        <span
                                                            class="requestReviewFieldLabel"
                                                            [textContent]="field.displayName + ' :'"></span>
                                                        <span class="requestReviewFieldValue" [textContent]="field.value"></span>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="requestReviewDataContainer">
                                        <div class="reviewPreCaptureHeader">
                                            <span [textContent]="translate('Input Details') + ':'"></span>
                                        </div>
                                        <div class="noTrasformationSelectedCls">
                                            <div class="renderContent">
                                                <div class="requestReviewFieldContainer col-3 noPadding">
                                                    <span
                                                        class="requestReviewFieldLabel"
                                                        [textContent]="translate('Input type') + ' :'"></span>
                                                    <span
                                                        class="requestReviewFieldValue"
                                                        [textContent]="translate('Electronic form')"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="1">
                                    <div class="requestReviewDataContainer">
                                        <div class="reviewPreCaptureHeader">
                                            <span [textContent]="translate('Input Details') + ':'"></span>
                                        </div>
                                        <div class="noTrasformationSelectedCls">
                                            <div class="renderContent">
                                                <div class="row noPadding">
                                                    <div class="requestReviewFieldContainer col-12 noPadding">
                                                        <span class="requestReviewFieldLabel">
                                                            <span [textContent]="translate('Input type') + ' :'"></span>
                                                        </span>
                                                        <span
                                                            class="requestReviewFieldValue"
                                                            [textContent]="translate('File Upload')"></span>
                                                    </div>
                                                </div>
                                                <div class="row noPadding">
                                                    <div class="requestReviewFieldContainer col-12 noPadding">
                                                        <span class="requestReviewFieldLabel">
                                                            <span [textContent]="translate('Selected Transformation') + ' :'"></span>
                                                        </span>
                                                        <span
                                                            class="requestReviewFieldValue"
                                                            [textContent]="
                                                                selectedTransformation &&
                                                                (selectedTransformation.displayName || selectedTransformation.chainName)
                                                            "></span>
                                                    </div>
                                                </div>
                                                <ng-container *ngIf="sourceTableData.value && sourceTableData.value.length > 0">
                                                    <div class="reviewHeaderDiv">
                                                        <span [textContent]="translate('Uploaded Files') + ':'"></span>
                                                    </div>
                                                    <div class="row noPadding">
                                                        <ng-container *ngIf="sourceTableData.value && sourceTableData.value.length === 1">
                                                            <ng-container *ngFor="let source of sourceTableData.value">
                                                                <div class="requestReviewFieldContainer col-12 noPadding">
                                                                    <span
                                                                        class="requestReviewFieldLabel"
                                                                        [title]="translate('Source Name')">
                                                                        <span [textContent]="source.name + ' :'"></span>
                                                                    </span>
                                                                    <span
                                                                        class="requestReviewFieldValue"
                                                                        [title]="translate('File Name')"
                                                                        [textContent]="source.fileName"></span>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                        <ng-container *ngIf="sourceTableData.value && sourceTableData.value.length > 1">
                                                            <ng-container *ngFor="let source of sourceTableData.value">
                                                                <div class="requestReviewFieldContainer col-4 noPadding">
                                                                    <span
                                                                        class="requestReviewFieldLabel"
                                                                        [title]="translate('Source Name')">
                                                                        <span [textContent]="source.name + ' :'"></span>
                                                                    </span>
                                                                    <span
                                                                        class="requestReviewFieldValue"
                                                                        [title]="translate('File Name')"
                                                                        [textContent]="source.fileName"></span>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="2">
                                    <div class="requestReviewDataContainer">
                                        <div class="reviewPreCaptureHeader">
                                            <span [textContent]="translate('Input Details') + ':'"></span>
                                        </div>
                                        <div class="noTrasformationSelectedCls">
                                            <div class="renderContent">
                                                <div class="row">
                                                    <div class="requestReviewFieldContainer col-3 noPadding">
                                                        <span class="requestReviewFieldLabel">
                                                            <span [textContent]="translate('Input type') + ' :'"></span>
                                                        </span>
                                                        <span
                                                            class="requestReviewFieldValue"
                                                            [textContent]="translate('Pull from App')"></span>
                                                    </div>

                                                    <div
                                                        class="requestReviewFieldContainer col-12 noPadding"
                                                        *ngIf="bridgeSourceNodes && bridgeSourceNodes.length > 0">
                                                        <div class="row">
                                                            <div class="requestReviewFieldLabel noPadding">
                                                                <span [textContent]="translate('Source Names') + ':'"></span>
                                                            </div>
                                                            <div class="col-9">
                                                                <ng-container *ngFor="let sourceName of bridgeSourceNodes">
                                                                    <div class="requestReviewFieldValue col-3">
                                                                        <span [textContent]="sourceName.name"></span>
                                                                    </div>
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="bridgeSourceNodes && bridgeSourceNodes.length === 0">
                                                    <div class="requestReviewDataContainer">
                                                        <div class="requestReviewFieldContainer col-12 noPadding">
                                                            <span class="requestReviewFieldLabel">
                                                                <span [textContent]="translate('Selected Transformation') + ' :'"></span>
                                                            </span>
                                                            <span
                                                                class="requestReviewFieldValue"
                                                                [textContent]="
                                                                    selectedAssetToAssetTransformation &&
                                                                    (selectedAssetToAssetTransformation.displayName ||
                                                                        selectedTransformation.chainName)
                                                                "></span>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="requestReviewDataContainer"
                                                        *ngIf="
                                                            selectedSearchAssetToAssetTrnsName?.length > 0 &&
                                                            selectedAssetToAssetTransformation.isSearchAsset
                                                        ">
                                                        <ng-container
                                                            *ngFor="let source of selectedSearchAssetToAssetTransformation.sourceParts">
                                                            <ng-container
                                                                *ngIf="!(source?.copyOf?.length > 0) && source?.appDetails?.metaData">
                                                                <div class="col-12 px-0 mt-4 flex">
                                                                    <div class="col-2 px-0 appDisplayName">
                                                                        <span
                                                                            [textContent]="
                                                                                source?.appDetails?.metaData?.displayName
                                                                            "></span>
                                                                    </div>
                                                                    <div class="col-10 mb-4">
                                                                        <ng-container
                                                                            *ngTemplateOutlet="
                                                                                customSearch;
                                                                                context: { source: source, disabled: true }
                                                                            "></ng-container>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                    <div class="requestReviewDataContainer">
                                                        <div class="row">
                                                            <div
                                                                class="reviewSelectedOrganizationsHeader requestReviewFieldLabel col-3 noPadding">
                                                                <span [textContent]="translate('Selected Organizations') + ' :'"></span>
                                                            </div>
                                                            <div class="reviewTenantNamesDisplayContainer col-9 noPadding">
                                                                <div class="row">
                                                                    <ng-container
                                                                        *ngFor="let orgid of allTenantsMap | ObjNgFor; let i = index">
                                                                        <ng-container
                                                                            *ngIf="allTenantsMap[orgid] && allTenantsMap[orgid].selected">
                                                                            <div class="reviewTenantNameDisplay col-4 noPadding">
                                                                                <span
                                                                                    [textContent]="
                                                                                        allTenantsMap[orgid].displayTenantName ||
                                                                                        allTenantsMap[orgid].name
                                                                                    "></span>
                                                                            </div>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="filingAttributeSubmitButn" id="reviewBtnDiv">
                            <material-button
                                class="pull-left"
                                [text]="translate('Back')"
                                [color]="'default'"
                                (buttonClicked)="goToBackPage()"></material-button>
                            <material-button
                                [classList]="['!w-auto', 'mx-2']"
                                [text]="translate('Cancel')"
                                [color]="'default'"
                                (buttonClicked)="cancelEntity(false)"></material-button>
                            <material-button
                                [classList]="['!w-auto', 'mx-2']"
                                class="nextBtnCls"
                                [text]="translate('Initiate Process')"
                                *ngIf="selectedIndex === 0"
                                [color]="'primary'"
                                (buttonClicked)="submitAttributeFields()"></material-button>
                            <material-button
                                [classList]="['!w-auto', 'mx-2']"
                                class="nextBtnCls"
                                [text]="translate('Initiate Process')"
                                *ngIf="selectedIndex === 1"
                                [color]="'primary'"
                                (buttonClicked)="uploadFile()"></material-button>
                            <material-button
                                [classList]="['!w-auto', 'mx-2']"
                                class="nextBtnCls"
                                [text]="translate('Initiate Process')"
                                *ngIf="selectedIndex === 2"
                                [color]="'primary'"
                                (buttonClicked)="
                                    selectedAssetToAssetTransformation?.isSearchAsset
                                        ? startSearchAssetTransformation()
                                        : startAssetToAssetTransformation()
                                "></material-button>
                        </div>
                    </ng-container>
                </mat-step>
            </mat-horizontal-stepper>
        </div>
    </perfect-scrollbar>
</div>

<ng-template #customSearch let-source="source" let-disabled="disabled">
    <ng-container *ngIf="source?.appDetails?.metaData?.uid">
        <mat-tab-group class="w-100" [selectedIndex]="source.selectedSearchTab" *transloco="let translate">
            <mat-tab [label]="translate('Rules')">
                <app-search-builder [search]="source?.search" [disabled]="disabled" searchType="SEARCH"></app-search-builder>
                <div [hidden]="disabled" class="d-flex flex-wrap align-items-center justify-content-end gap-2 pb-1 mt-4">
                    <material-button
                        [classList]="['!w-auto', 'mr-2']"
                        [color]="'primary'"
                        [text]="!source.search.criteriaUpdated ? translate('Add Criteria') : translate('Update Criteria')"
                        (buttonClicked)="source.search.buildCriterias(); saveFilterDisabled = false"></material-button>
                    <div class="saveFilter d-inline-flex align-items-center flex-wrap gap-2">
                        <input
                            matInput
                            [disabled]="!source.search.criteriaUpdated || isSavedFilterViewed"
                            type="text"
                            class="searchBorder !w-[200px] !py-2 !pl-2"
                            [placeholder]="translate('Enter Filter Name')"
                            [(ngModel)]="saveFilterName"
                            (ngModelChange)="saveFilterName = $event" />
                        <span></span>
                        <material-button
                            [disabled]="saveFilterDisabled"
                            [classList]="['!w-auto', 'ml-2']"
                            [color]="'primary'"
                            [text]="!isSavedFilterViewed ? translate('Save Filter') : translate('Update Filter')"
                            (buttonClicked)="saveSearchFilter(!isSavedFilterViewed ? 'save' : 'update', source)"></material-button>
                    </div>
                </div>
            </mat-tab>
            <mat-tab [label]="translate('Relations')">
                <div class="relationsTab pt-4">
                    <div class="queryBuilderMainCntr">
                        <app-search-builder
                            [disabled]="disabled"
                            [search]="source.search"
                            [showQueryBuilderDirectly]="true"
                            searchType="RELATION"></app-search-builder>
                    </div>
                    <div [hidden]="disabled" class="d-flex flex-wrap align-items-center justify-content-end gap-2 pb-1 mt-4">
                        <material-button
                            [color]="'primary'"
                            [classList]="['!w-auto', 'mr-2']"
                            [text]="translate('Apply Relations')"
                            (buttonClicked)="source.search.applyRelations(); saveFilterDisabled = false"></material-button>
                        <div class="saveFilter d-inline-flex align-items-center flex-wrap gap-2">
                            <input
                                matInput
                                [disabled]="!source.search.criteriaUpdated || isSavedFilterViewed"
                                type="text"
                                class="searchBorder !w-[200px] !py-2 !pl-2"
                                [placeholder]="translate('Enter Filter Name')"
                                [(ngModel)]="saveFilterName"
                                (ngModelChange)="saveFilterName = $event" />
                            <span></span>
                            <material-button
                                [disabled]="saveFilterDisabled"
                                [classList]="['!w-auto', 'ml-2']"
                                [color]="'primary'"
                                [text]="!isSavedFilterViewed ? translate('Save Filter') : translate('Update Filter')"
                                (buttonClicked)="saveSearchFilter(!isSavedFilterViewed ? 'save' : 'update', source)"></material-button>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </ng-container>
</ng-template>

<ng-template #noTransformation>
    <div *transloco="let translate">
        <div class="noTrasformationSelectedCls">
            <span class="renderContent" [textContent]="translate('Please select a transformation')"></span>
        </div>
    </div>
</ng-template>

<ng-template #noBusinessKeys>
    <div *transloco="let translate">
        <div class="noTrasformationSelectedCls">
            <span class="renderContent" [textContent]="translate('No Business keys found')"></span>
        </div>
    </div>
</ng-template>

<ng-template #noFilingAtributes>
    <div *transloco="let translate">
        <div class="noTrasformationSelectedCls">
            <span class="renderContent" [textContent]="translate('No Pre-Capture Attributes found')"></span>
        </div>
    </div>
</ng-template>

<ng-template #noTransformationFound>
    <div *transloco="let translate">
        <div class="noTrasformationSelectedCls">
            <span class="renderContent" [textContent]="translate('No transformations found for this app')"></span>
        </div>
    </div>
</ng-template>

<ng-template #notificationPopupModal *transloco="let translate">
    <div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
        <h4 class="matDialogTitle" mat-dialog-title><span [textContent]="translate('Alert') + '!'"></span></h4>
        <span class="material-icons mb-1" mat-dialog-close>close</span>
    </div>
    <mat-dialog-content class="mat-typography">
        <span [textContent]="notificationPopupMessage"></span>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <material-button class="mx-4" [text]="translate('Close')" [color]="'default'" (buttonClicked)="closePopup()"></material-button>
        <material-button [text]="translate('Continue')" [color]="'primary'" (buttonClicked)="processSourceInstances()"></material-button>
    </mat-dialog-actions>
</ng-template>

<ng-template #manualTemplate>
    <div
        class="electronicForm row"
        *ngIf="businessKeysRecord && businessKeysRecord.fields && businessKeysRecord.fields.length > 0; else noBusinessKeys">
        <ng-container *ngFor="let field of businessKeysRecord.fields">
            <div class="col-3" *ngIf="field.isBusinessKey && !field.autoCalculate && !isFieldInFilingAttributes(field)">
                <div [class.formFieldContainer]="field.uiTypeMetadata !== 'TEXTAREA'">
                    <ng-container *ngIf="field && currentApp?.assetMetaUId">
                        <lib-field-input
                            [enableField]="true"
                            [field]="field"
                            [record]="businessKeysRecord"
                            (modelChange)="field.value = $event"
                            [service]="currentApp"
                            [bridge]="currentBridge"
                            [masterEntityFieldValueMap]="masterEntityFieldValueMap"
                            [fieldsMap]="fieldsMap"></lib-field-input>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #fileUpload>
    <div *transloco="let translate">
        <div class="trasformationListDiv">
            <material-selectgroup
                [required]="true"
                [options]="transformations"
                [placeholder]="translate('Select Transformation')"
                [model]="selectedTransformationName"
                [optionDisplayNameProperty]="'chainDisplayName'"
                [optionValueProperty]="'id'"
                (modelChange)="selectedTransformationName = $event; getSelectedTransformation()"
                [groupDisplayNameProperty]="'orgName'"
                [groupValueProperty]="'transformations'"
                [title]="selectedTransformationName"
                [noOptionsInstruction]="translate('No active transformations found')"></material-selectgroup>
        </div>
        <div *ngIf="selectedTransformationName?.length; else noTransformation" class="transformationTableDiv">
            <div class="sourceTableHeaderClass">
                <span [textContent]="translate('Upload below files to initiate process')"></span>
            </div>
            <div>
                <source-table
                    [sourceParts]="sourceTableData"
                    [sourceTableColumns]="sourceTableColumns"
                    [hidePaginator]="hidePaginator"
                    [primaryColumns]="primaryColumns"
                    (downloadSourceTemplateUrl)="downloadSourceTemplateUrl($event)"
                    (isFileUploaded)="scrollToBottm($event)"></source-table>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #pullFromApp>
    <div *transloco="let translate">
        <div *ngIf="currentBridge?.restApiName && bridgeSourceNodes?.length" class="assetToAssetInBridgeCls">
            <div class="requestReviewDataContainer" *ngIf="bridgeSourceNodes?.length; else noTransformationFound">
                <div class="reviewPreCaptureHeader"><span [textContent]="translate('Source Names') + ':'"></span></div>
                <ng-container *ngFor="let sourceName of bridgeSourceNodes">
                    <div class="requestReviewFieldContainer col-3">
                        <span [textContent]="sourceName.name"></span>
                    </div>
                </ng-container>
            </div>
        </div>
        <div
            *ngIf="
                !currentBridge ||
                (currentBridge && !currentBridge.restApiName) ||
                (currentBridge && currentBridge.restApiName && bridgeSourceNodes && bridgeSourceNodes.length === 0)
            ">
            <div class="trasformationListDiv">
                <material-selectgroup
                    [required]="true"
                    [options]="assetToAssetTransformations"
                    [placeholder]="translate('Select Transformation')"
                    [model]="selectedAssetToAssetTrnsName"
                    [optionDisplayNameProperty]="'chainDisplayName'"
                    [optionValueProperty]="'id'"
                    (modelChange)="selectedAssetToAssetTrnsName = $event; getSelectedAssetToAssetTransformation()"
                    [groupDisplayNameProperty]="'orgName'"
                    [title]="selectedAssetToAssetTrnsName"
                    [groupValueProperty]="'transformations'"
                    [noOptionsInstruction]="translate('No active transformations found')"></material-selectgroup>
            </div>
            <div
                class="transformationTableDiv assettoasset"
                *ngIf="
                    selectedAssetToAssetTrnsName &&
                    selectedAssetToAssetTrnsName.length > 0 &&
                    selectedAssetToAssetTransformation.isAssetToAsset === true
                ">
                <div class="filteringAttributesDiv" *ngIf="filteringAttributes && filteringAttributes.length > 0">
                    <div class="filterAttributesHeaderDiv">
                        <span [textContent]="translate('Filtering Attributes') + ':'"></span>
                    </div>
                    <div class="preCaptureAttributeFieldsContainer d-flex flex-wrap">
                        <ng-container *ngFor="let field of filteringAttributes">
                            <div class="col-3 fieldInput" *ngIf="field && !field.autoCalculate && currentApp?.assetMetaUId">
                                <filingattribute-field
                                    [field]="field"
                                    [record]="filteringAttributes"
                                    [service]="currentApp"
                                    [type]="'filingDate'"
                                    [bridge]="currentBridge"
                                    [metaData]="assetMetaData"
                                    [fieldsMap]="fieldsMap"
                                    [masterEntityFieldValueMap]="masterEntityFieldValueMap"></filingattribute-field>
                                `
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div
                class="source-filters organizationsListContainer"
                *ngIf="selectedSearchAssetToAssetTrnsName?.length > 0 && selectedAssetToAssetTransformation.isSearchAsset">
                <div class="orgSelectDivHeader col-12 mb-[24px]">
                    <span [textContent]="translate('Search') + ':'"></span>
                </div>
                <ng-container *ngFor="let source of selectedSearchAssetToAssetTransformation.sourceParts">
                    <ng-container *ngIf="!(source.copyOf?.length > 0) && source?.appDetails?.metaData">
                        <div class="col-12 px-0 mt-4 flex">
                            <div class="col-2 px-0 appDisplayName">
                                <span [textContent]="source?.appDetails?.metaData?.displayName"></span>
                            </div>
                            <div class="col-10 mb-4">
                                <div class="absolute filterClass !z-10 !right-[10px] flex items-center justify-end">
                                    <mat-form-field appearance="outline" class="!mr-[10px] !w-[160px]" appRemoveAriaOwns>
                                        <mat-select
                                            [placeholder]="translate('Select Filter')"
                                            class="pl-[10px] dropIcon"
                                            [(value)]="selectedFilter">
                                            <mat-option [value]="">
                                                <em [textContent]="'--' + translate('Please select') + '--'"></em>
                                            </mat-option>
                                            <mat-form-field class="searchContentClass">
                                                <input
                                                    matInput
                                                    [placeholder]="translate('Search Filter')"
                                                    type="text"
                                                    [(ngModel)]="searchedFilter"
                                                    stop-propagation />
                                                <material-button
                                                    buttonType="icon"
                                                    [size]="'small'"
                                                    matSuffix
                                                    (buttonClicked)="searchedFilter = ''"
                                                    [prefixIcon]="searchedFilter ? 'close' : 'search'"
                                                    [classList]="['searchEntitiesIcons']"></material-button>
                                            </mat-form-field>
                                            <mat-option
                                                *ngFor="let filter of source?.defaultSearchFilters?.['default-filters'] | multiFilter:searchedFilter;"
                                                [value]="filter">
                                                <span [textContent]="filter"></span>
                                            </mat-option>
                                            <div
                                                class="noTemplatesMsg p-2"
                                                *ngIf="(source?.defaultSearchFilters?.['default-filters'] | multiFilter:searchedFilter)?.length === 0">
                                                <span [textContent]="translate('No Filter Found')"></span>
                                            </div>
                                        </mat-select>
                                    </mat-form-field>
                                    <material-button
                                        [color]="'primary'"
                                        [text]="translate('Apply Filter')"
                                        [classList]="['!w-auto', '!mt-[-20px]']"
                                        (buttonClicked)="bindingTemplateValues(source)"></material-button>
                                </div>
                                <ng-container *ngTemplateOutlet="customSearch; context: { source: source }"></ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container
                        *ngIf="!(source.copyOf?.length > 0) && !source?.appDetails?.metaData && !source?.appDetails?.metaDataLoading">
                        <span [textContent]="source?.sourceAssetOrMasterName + ' is not subscribed'"></span>
                    </ng-container>
                </ng-container>
            </div>
            <div class="organizationsListContainer row" *ngIf="selectedAssetToAssetTrnsName && selectedAssetToAssetTrnsName.length > 0">
                <div class="orgSelectDivHeader flex justify-content-between col-12">
                    <span [textContent]="translate('Select Organizations') + ':'"></span>
                </div>
                <fieldset class="w-full flex">
                    <div class="levelOneTenants col-6">
                        <mat-form-field class="searchTenants searchInputField">
                            <input matInput [placeholder]="translate('Search Organization')" type="text" [(ngModel)]="filterTenantName" />
                            <material-button
                                buttonType="icon"
                                [size]="'small'"
                                matSuffix
                                (buttonClicked)="filterTenantName = ''"
                                [prefixIcon]="filterTenantName ? 'close' : 'search'"
                                [classList]="['locationManagementIcons']"></material-button>
                        </mat-form-field>
                        <div class="tenantsList position-relative h-[40vh] overflow-y-auto">
                            <ng-container *ngIf="tenantsToRender | FilterPipe : 'name' : filterTenantName as result">
                                <div
                                    *ngFor="let tenant of result"
                                    class="flex items-center"
                                    (click)="
                                        selectAllOrganizations = !selectAllOrganizations;
                                        selectTenantAndSubTenantsForTransformation(tenant, selectAllOrganizations)
                                    ">
                                    <span class="organizationSelect">
                                        <material-checkbox
                                            class="pointer-events-none"
                                            [name]="'transOrgName' + tenant.name"
                                            [id]="'transOrgName' + tenant.id"
                                            [model]="selectAllOrganizations"></material-checkbox>
                                    </span>
                                    <button
                                        mat-menu-item
                                        type="button"
                                        [class.activeOrganization]="tenant.id === selectedTenantId"
                                        [title]="tenant.name + ' (' + tenant.orgLoginId + ')'">
                                        <span>
                                            <span [textContent]="tenant.name"></span>
                                            <span class="orgId" [textContent]="'(' + tenant.orgLoginId + ')'"></span>
                                        </span>
                                    </button>
                                </div>
                                <label
                                    class="noSearchResults"
                                    *ngIf="tenantsToRender?.length && !result?.length"
                                    [textContent]="translate('No organizations matching your search')"></label>
                            </ng-container>
                        </div>
                    </div>
                    <div class="tenantFlatStructure col-6">
                        <mat-form-field class="searchSubTenants searchInputField">
                            <input matInput [placeholder]="translate('Search Tenant')" type="text" [(ngModel)]="filterSubTenantName" />
                            <material-button
                                buttonType="icon"
                                [size]="'small'"
                                matSuffix
                                (buttonClicked)="clearSearchSubTenant()"
                                [prefixIcon]="filterSubTenantName ? 'close' : 'search'"
                                [classList]="['locationManagementIcons']"></material-button>
                        </mat-form-field>
                        <div>
                            <perfect-scrollbar
                                class="tenantsList position-relative h-[60vh]"
                                *ngIf="subTenants | FilterPipe : 'displayTenantName' : filterSubTenantName as result">
                                <div *ngFor="let subTenant of result" class="flex items-center" (click)="checkSubTenant(subTenant)">
                                    <span class="organizationSelect">
                                        <material-checkbox
                                            class="pointer-events-none"
                                            [name]="'transSubOrgName' + subTenant.name"
                                            [id]="'transSubOrgName' + subTenant.id"
                                            [model]="subTenant.selected"></material-checkbox>
                                    </span>
                                    <button
                                        mat-menu-item
                                        type="button"
                                        [title]="(subTenant.displayTenantName || subTenant.name) + ' (' + subTenant.orgLoginId + ')'">
                                        <span>
                                            <span [textContent]="subTenant.displayTenantName || subTenant.name"></span>
                                            <span class="orgId" [textContent]="'(' + subTenant.orgLoginId + ')'"></span>
                                        </span>
                                    </button>
                                </div>
                                <label
                                    class="noSearchResults"
                                    *ngIf="subTenants?.length && result?.length === 0"
                                    [textContent]="translate('No tenants matching your search')"></label>
                            </perfect-scrollbar>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</ng-template>
